import trackProductEvent from '../../utils/trackProductEvent';
import { LIMITED_STOCK, OUT_OF_STOCK } from '../../helpers/availability';
import sourceType from '../ShoppingBag/ShoppingBag.types';

// This event should fire when a customer clicks on the Add to Bag button on the Ungated PDP
// and the item is successfully added to the ungated shopping bag
export const trackAddToBagSuccess = ({ skuId, skuAvailability, subSource }) => {
  const eventName = 'ungated_add_to_bag';
  const canonicalName = 'pdp';
  const actionType = 'click';
  const actionName = 'add_to_bag';
  const actionDetail = 'ungated_shop';
  const trackingSku = {
    sku_id: skuId,
    limited_stock: skuAvailability === LIMITED_STOCK,
    out_of_stock: skuAvailability === OUT_OF_STOCK,
    quantity: 1,
    source: sourceType.UNGATED,
    sub_source: subSource,
  };

  const directBuyContext = { skus: [trackingSku] };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
  });
};

export const trackAddToBagToastClick = () => {
  const eventName = 'ungated_add_to_bag_toast_click';
  const canonicalName = 'pdp';
  const actionType = 'click';
  const actionName = 'add_to_bag_toast';
  const actionDetail = 'ungated_shop';

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
  });
};

export const trackBagCreatedEvent = ({ skuId, bagItem }) => {
  const eventName = 'ungated_bag_created';
  const canonicalName = 'shopping_bag';
  const actionType = 'event';
  const actionName = 'bag_created';
  const actionDetail = 'ungated_shop';
  const sku = {
    sku_id: skuId,
    quantity: bagItem?.quantity,
    source: 'ungated_shop',
    sub_source: bagItem?.sub_source,
  };
  const directBuyContext = { skus: [sku] };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
  });
};
